import { Factory } from 'miragejs'

function cycle(...args) {
  const items = args || []
  return (i) => {
    return items[i % items.length]
  }
}

export default Factory.extend({
  extension: cycle('au', 'us', 'uk', 'ca', 'nz'),
  description: cycle('Australian', 'US', 'UK', 'Canadian', 'New Zealand'),
})
